import {Box, Grid, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {type RequiredTestIdProps, suffixTestId} from 'shared/web';

import {useAbcXyzDetailView} from '../hooks/useAbcXyzDetailView';
import type {AbcXyzTabProps} from '../types/AbcXyzTabProps';
import {AbcXyzClassCard} from './AbcXyzClassCard';
import {AbcXyzDetailGrid} from './AbcXyzDetailGrid';
import {AbcXyzMetricsCard} from './AbcXyzMetricsCard';
import {AbcXyzThresholdsTable} from './AbcXyzThresholdsTable';
import {AbcXyzValueContributionChart} from './AbcXyzValueContributionChart';

const ABC_GRID_CODE = 'report-abc-calculation-details';
const TOP_COLUMNS = 3;
const SUMMARY_MIN_HEIGHT_STEPS = 64;
/** Keep several rows visible when a short viewport requires scrolling the dialog. */
const GRID_MIN_HEIGHT_STEPS = 48;

export function AbcXyzAbcTab(props: AbcXyzTabProps & RequiredTestIdProps) {
  const view = useAbcXyzDetailView(props.detail);

  return (
    <VStack spacing={2} height={['auto', 'auto', '100%']} minHeight={0}>
      <Grid columns={[1, 1, TOP_COLUMNS]} spacing={2} minHeight={SUMMARY_MIN_HEIGHT_STEPS}>
        <AbcXyzMetricsCard
          title={i18n.t('entity.warehouse.reporting.keyFigures')}
          metrics={view.abcMetrics}
          data-testid={suffixTestId('keyFigures', props)}
        />
        <Box height={[SUMMARY_MIN_HEIGHT_STEPS, SUMMARY_MIN_HEIGHT_STEPS, '100%']}>
          <AbcXyzValueContributionChart
            detail={props.detail}
            data-testid={suffixTestId('valueChart', props)}
          />
        </Box>
        <VStack spacing={2}>
          <AbcXyzClassCard
            title={i18n.t('entity.warehouse.reporting.abcClass')}
            classLetter={props.detail.abcClass}
            name={view.abcName}
            hint={view.abcHint}
            colorScheme="green"
            data-testid={suffixTestId('abcClassCard', props)}
          />
          <AbcXyzThresholdsTable
            title={i18n.t('entity.warehouse.reporting.abcThresholdsTitle')}
            thresholds={view.abcThresholds}
            data-testid={suffixTestId('thresholds', props)}
          />
        </VStack>
      </Grid>
      <Box
        flex={[undefined, undefined, 1]}
        height={[GRID_MIN_HEIGHT_STEPS, GRID_MIN_HEIGHT_STEPS, undefined]}
        minHeight={GRID_MIN_HEIGHT_STEPS}
      >
        <AbcXyzDetailGrid
          gridCode={ABC_GRID_CODE}
          articleId={props.articleId}
          data-testid={suffixTestId('abcGrid', props)}
        />
      </Box>
    </VStack>
  );
}
